export default __webpack_public_path__ + "static/media/icon-next.a9b74ec3.svg";